import React from 'react';
import { Accordion, Col, Container } from '@everlywell/leaves';

import SectionWrapper from 'components/SectionWrapper';
import * as S from './styles';
import { FAQ } from 'utils/types';
import { sanitize } from 'utils/domHelpers';
import { generateKey } from 'utils/helpers';

export interface FAQSectionProps {
  faqs: FAQ[];
  title?: string;
  handleFAQClick?: Function;
}

export const FAQSection: React.FC<FAQSectionProps> = ({
  faqs,
  // Provide a default to preserve the interface, just in case.
  // TODO: remove the default if we are confident we don't have any
  // uses of this component that don't supply a title..
  title = 'Questions?',
  handleFAQClick = () => {},
}) => {
  return faqs.length > 0 ? (
    <SectionWrapper data-testid="faqSection">
      <Container>
        <S.Row>
          <S.SectionHeader>{title}</S.SectionHeader>
        </S.Row>
        <S.Row>
          <Col>
            {faqs.map(faq => (
              <Accordion.Wrapper key={generateKey()}>
                <Accordion.Item>
                  <S.Heading onClick={handleFAQClick(faq.question)}>
                    <S.Title>{faq.question}</S.Title>
                  </S.Heading>
                  <S.Content>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: sanitize(faq.answer),
                      }}
                    />
                  </S.Content>
                </Accordion.Item>
              </Accordion.Wrapper>
            ))}
          </Col>
        </S.Row>
      </Container>
    </SectionWrapper>
  ) : null;
};

export default FAQSection;
